'use client';

import DefaultLayout from '@/layouts/DefaultLayout';
import withLayout from './hoc/withLayout';
import Hero from '@/components/Hero/Hero';
import EventSlider from '@/components/Event/EventSlider';
import QuoteOfTheWeek from '@/components/Quote/QuoteOfTheWeek';
import OrientationCallCard from '@/components/Card/OrientationCallCard';
import LiveCoursesSection from '@/components/LiveCourse/LiveCoursesSection';
import MediaLibrarySection from '@/components/MediaLibrary/MediaLibrarySection';
import OurExperts from '@/components/Experts/OurExperts';
import PartnersSection from '@/components/Partners/PartnersSection';
import StressLevelChartComponent from '@/components/StressTest/StressLevelChartComponent';
import { useSelectedCategories } from '@/redux/selectors/categorySelector';
import LiveCourseSlider from '@/components/Slider/LiveCourseSlider';
import VideoCourseSlider from '@/components/Slider/VideoCourseSlider';
import ExpertSlider from '@/components/Slider/ExpertSlider';
import PartnerSlider from '@/components/Slider/PartnerSlider';
import VideoSlider from '@/components/Slider/VideoSlider';
import { useEffect } from 'react';
import { ROUTES } from '@/config/routes';
import { useUser } from '@clerk/nextjs';

const LandingPage = () => {
  const activeCategories = useSelectedCategories();
  const { user } = useUser();

  // TODO(routing): this should all be handled in middleware.
  useEffect(() => {
    if (!user) {
      return;
    }
    const roles = Array.isArray(user?.publicMetadata?.roles)
      ? (user.publicMetadata.roles as string[])
      : [];

    if (user && roles.includes('exp_user_mgmt_admin_int')) {
      window.location.href = ROUTES.EXPERT_DASHBOARD;
    }
  }, [user]);

  // When no filters are selected do no show booking components
  const shouldShowComponents = activeCategories.length === 0 || activeCategories.includes('all');

  if (shouldShowComponents) {
    return (
      <div className="bg-white">
        <Hero />
        <EventSlider />
        <StressLevelChartComponent />
        <QuoteOfTheWeek />
        <OrientationCallCard />
        <LiveCoursesSection />
        <MediaLibrarySection />
        <OurExperts />
        <PartnersSection />
      </div>
    );
  } else {
    return (
      <div className="bg-white">
        <EventSlider />
        <LiveCourseSlider />
        <VideoSlider />
        <VideoCourseSlider />
        <ExpertSlider />
        <PartnerSlider />
        <OrientationCallCard />
      </div>
    );
  }
};

export default withLayout(LandingPage, DefaultLayout);
